import PropTypes from 'prop-types';
import React from 'react';

import {Box, IconButton, Typography} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import NearMeIcon from '@mui/icons-material/NearMe';

import {alpha} from '@mui/material/styles';

export const Wrapper = props => (
  <Box
    sx={{
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      height: theme => theme.spacing(3),
      background: theme => `${alpha(theme.palette.grey[900], 0.95)}`,
      paddingRight: 2,
      overflow: 'hidden',
      zIndex: 'appBar',
      position: 'relative',
    }}
    {...props}
  />
);

export const Label = React.forwardRef(({sx, ...props}, ref) => (
  <Typography
    color="inherit"
    variant="caption"
    component="div"
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        marginY: 0,
        marginX: 1,
        zIndex: 1,
        '& > svg': {
          marginRight: 0.5,
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
    ref={ref}
  />
));

Label.propTypes = {
  sx: PropTypes.object,
};

export const ScaleContainer = React.forwardRef((props, ref) => (
  <Label
    sx={{
      minWidth: 140,
      justifyContent: 'flex-end',
      '& .pl-scale-line-inner': {
        borderBottom: '1px solid #eee',
        textAlign: 'right',
        willChange: 'contents, width',
        transition: 'all 0.25s',
      },
    }}
    {...props}
    ref={ref}
  />
));

export const CurrentLocation = React.forwardRef((props, ref) => (
  <Label
    sx={{
      minWidth: 200,
      '&:hover': {
        cursor: 'pointer',
      },
    }}
    {...props}
    ref={ref}
  >
    <NearMeIcon fontSize="inherit" />
  </Label>
));

export const CloseButton = props => (
  <IconButton
    size="small"
    color="inherit"
    sx={{
      fontSize: 'body2.fontSize',
      borderRadius: 0,
      '&:hover': {
        background: 'primary.dark',
      },
    }}
    {...props}
  >
    <CloseIcon name="close" fontSize="inherit" />
  </IconButton>
);

export const AttributionContainer = React.forwardRef((props, ref) => (
  <Label
    sx={{
      fontSize: theme => theme.typography.pxToRem(12),
      marginRight: 'auto',
      '& .ol-attribution.ol-uncollapsible': {
        position: 'relative',
        background: 'transparent',
        '& ul': {
          color: 'inherit',
          textShadow: 'none',
          padding: 0,
          width: '100%',
        },
        '& a': {
          color: 'inherit',
        },
      },
    }}
    {...props}
    ref={ref}
  />
));
